import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TourMatMenu } from 'ngx-ui-tour-md-menu';
import { InvestorDetails } from 'src/app/models/classes/investor-dashboard.class';
import { CurrencyFormatPipe } from 'src/app/pipes/currency-format.pipe';
import { InfoTextBoxComponent } from 'src/app/shared/info-text-box/info-text-box.component';

@Component({
    selector: 'app-investor-summary',
    imports: [CommonModule, InfoTextBoxComponent, CurrencyFormatPipe, TourMatMenu],
    templateUrl: './investor-summary.component.html',
    styleUrls: ['./investor-summary.component.scss']
})
export class InvestorSummaryComponent {
  readonly investorSummary = input<InvestorDetails | undefined>(undefined);
  readonly iconSet = input<Record<string, string>>({});
  readonly showBanner = input<boolean | undefined>(undefined);
  investorId!: string;
}
